import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './LoadingSpinner.scss';

/**
 * LoadingSpinner
 * @param {string} colorScheme - 'red', 'green', or 'blue'
 * @param {string} size - 'small' or 'large'
 * @param {object} props - any additional props like data-testid
 */
export default function LoadingSpinner({ 
  colorScheme = null, 
  size = 'small',
  ...props 
}) {
  return (
    <div
      {...props}
      role="status"
      data-testid="loading-spinner"
      className={classNames(
        'loading-spinner',
        colorScheme && `loading-spinner--${colorScheme}`,
        `loading-spinner--${size}`
      )}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

LoadingSpinner.propTypes = {
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue']),
  size: PropTypes.oneOf(['small', 'large'])
};
